// Case Files layout: the viewer is the right half of one unified container, so
// it drops the floating shadow/radius and squares off its left edge to meet the
// file list.
.joined {
    border: 1px solid #eaecf0;
    border-left: none;
    border-radius: 0 12px 12px 0;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.06);
    overflow: hidden;
    background-color: #ffffff;
}
